import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { KioskService } from '../kiosk.service';

@Component({
  selector: 'app-kiosk-edit-tenant-dialog',
  templateUrl: './kiosk-edit-tenant-dialog.component.html',
  styleUrls: ['./kiosk-edit-tenant-dialog.component.css']
})
export class KioskEditTenantDialogComponent implements OnInit {
  kiosk;
  kioskInProgress;
  loading = false;

  tenants = [];

  constructor(
    public dialogRef: MatDialogRef<KioskEditTenantDialogComponent>,
    private _kioskService: KioskService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { kiosk: any }) { }

  ngOnInit() {
    this.kiosk = this.data.kiosk;
  }

  tenantsChanged(t: any) {
    this.tenants = [];
    t.forEach(el => {
      this.tenants.push({account_id: el.account_id, contact: {name: el.name}});
    });
  }


  saveTenants() {
    this.loading = true;
    this._kioskService.inviteTenants({tenants: this.tenants, kiosk_id: this.kiosk.id}).subscribe((d) => {
      this.loading = false;
      this.dialogRef.close('refresh');
    }, (error) => {
      this.snackBar.open('Error:' + error.error.code, 'Okay', {
        duration: 2000,
      });
      this.loading = false;

      console.log('an error occurred', error);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component.ts